import React from "react";
import "../styles/UserManagement.css";
import { useState } from "react";
import UserManageHeaderIcon from "../icons/BusinessHub/UserManageHeaderIcon.js";
import PlusIcon from "../icons/BusinessHub/PlusIcon.js";
import UserManagmentUsers from "./UserManagmentUsers.js";
import UsermanageRolesandPermisions from "./UsermanageRolesandPermisions.js";
import { useNavigate } from "react-router-dom";

function UserManagement() {
  const navigate = useNavigate();
  const [UsersDiv, setUsersdiv] = useState(true);
  const [RandPDiv, setRandPdiv] = useState(false);

  const handleRolediv = () => {
    if (UsersDiv) {
      setUsersdiv(false);
    }
    if (!RandPDiv) {
      setRandPdiv(true);
    }
  };

  const handleUser = () => {
    if (RandPDiv) {
      setRandPdiv(false);
    }
    if (!UsersDiv) {
      setUsersdiv(true);
    }
  };

  return (
    <div className="user-management-main-container">
      <div className="user-management-header">
        <div className="user-management-header-icon">
          <UserManageHeaderIcon />
        </div>
        <div className="user-management-title-container">
          <div className="user-management-title">User Management</div>
          <div className="user-mangement-header-text">
            Manage all users in one place. Control access, assign roles, and
            monitor activity across your platform.
          </div>
        </div>
        {UsersDiv ? (
          <div
            className="user-management-new-user"
            onClick={() => navigate("/add-user")}
          >
            <PlusIcon fill="currentColor" /> New User
          </div>
        ) : (
          <div
            className="user-management-new-user"
            onClick={() => navigate("/add-role")}
          >
            <PlusIcon fill="currentColor" /> New Role
          </div>
        )}
      </div>
      <div className="management-users-roles-permissions">
        <div
          className={
            UsersDiv
              ? "management-manage-users-selected"
              : "management-manage-users"
          }
          onClick={() => {
            handleUser();
          }}
        >
          Users
        </div>
        <div
          className={
            RandPDiv
              ? "management-manage-users-selected"
              : "management-manage-users"
          }
          onClick={handleRolediv}
        >
          Roles & Permissions
        </div>
      </div>
      {UsersDiv ? (
        <div className="users-managening">
          <UserManagmentUsers />
        </div>
      ) : (
        <div className="users-managening">
          <UsermanageRolesandPermisions />
        </div>
      )}
    </div>
  );
}

export default UserManagement;
